import { EDynamicFormField, IField } from '@app/modules'

import { StyledAppleIcon, StyledGoogleIcon } from '~public'

export const SIGN_IN_FORM: IField[] = [
  {
    label: 'Email',
    name: 'email',
    placeholder: 'Enter Email',
    rules: [
      {
        message: 'Email is required',
        required: true,
      },
    ],
    type: EDynamicFormField.EMAIL,
  },
  {
    label: 'Password',
    name: 'password',
    placeholder: 'Enter Password',
    rules: [
      {
        message: 'Password is required',
        required: true,
      },
    ],
    type: EDynamicFormField.PASSWORD,
  },
  {
    href: '/auth/forgot-password',
    name: 'forgotYourPassword',
    placeholder: '',
    rules: [
      {
        required: false,
      },
    ],
    title: 'Forgot Your Password?',
    type: EDynamicFormField.NAVIGATION,
  },
  {
    name: 'button',
    rules: [
      {
        required: true,
      },
    ],
    title: 'Log In',
    type: EDynamicFormField.PRIMARY_BUTTON,
  },
  {
    name: 'dividerText',
    placeholder: '',
    rules: [
      {
        required: true,
      },
    ],
    title: 'or',
    type: EDynamicFormField.TEXT_DIVIDER,
  },
  {
    icon: <StyledGoogleIcon marginRight="10px" />,
    name: 'google',
    rules: [
      {
        required: true,
      },
    ],
    title: 'Continue with Google',
    type: EDynamicFormField.ICON_BUTTON,
  },
  {
    icon: <StyledAppleIcon marginRight="10px" />,
    name: 'apple',
    rules: [
      {
        required: true,
      },
    ],
    title: 'Continue with Apple',
    disabled: true,
    type: EDynamicFormField.ICON_BUTTON,
  },
  {
    name: 'link',
    title: 'Send a sign-in link',
    type: EDynamicFormField.SECONDARY_BUTTON,
  },
]
